<template>
  <pt-policy-detail class="pt-policy-detail__page" :id="id" :type="type"></pt-policy-detail>
</template>

<script>
import PtPolicyDetail from 'cps/other-service/pt-policy-manage/pt-policy-detail/withData'
export default {
  name: 'pt-policy-detail__view',
  components: {
    'pt-policy-detail': PtPolicyDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
